import React from 'react';
import LiveRecorder from './components/LiveRecorder';

function App() {
  return (
    <div className="app">
      <header className="app-header">
        <h1>🎤 Voice Recorder Video Generator</h1>
        <p className="app-description">
          Record your voice with live video preview - see your final video in real-time!
        </p>
      </header>
      <LiveRecorder />
    </div>
  );
}

export default App;
